import React, { useState } from 'react';

import { Row, Col, Flex } from 'antd';
import styled from 'styled-components';

import { TimeLineAltCard } from './TimelineAltCard';
import { TimeLineMainCard } from './TimeLineMainCard';
import { CancelLifecyleModal } from '../../boxes/components/lifecycle/CancelLifecyleModal';

const VerticalLine = styled.div`
  border-left: 1.5px solid #00bf6f;
  height: 100%;
  margin-left: 2.5px;
`;

const Dot = styled.div`
  height: 6px;
  width: 6px;
  background-color: #00bf6f;
  border-radius: 50%;
  display: inline-block;
`;

export const TimeLineRow = ({
  timeLineEvent,
  index,
  isDeletable,
  lpUi,
  onRefetch,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Row gutter={0} style={{ minHeight: '100px' }}>
      <Col flex="20px" style={{ display: 'flex', alignItems: 'stretch' }}>
        <Flex
          vertical
          style={{
            height: '100%',
            width: '100%',
          }}
        >
          <Flex style={{ flex: '3 1 0', minHeight: '30px' }}>
            <VerticalLine />
          </Flex>
          <Flex
            align="center"
            style={{
              flex: '1 1 0',
              minHeight: '10px',
            }}
          >
            <Dot />
          </Flex>
          <Flex style={{ flex: '3 1 0', minHeight: '30px' }}>
            <VerticalLine />
          </Flex>
        </Flex>
      </Col>
      <Col
        flex="1"
        style={{
          width: '100%',
          paddingBottom: '1rem',
          paddingTop: index === 0 || timeLineEvent.sub_status ? 0 : '2rem',
        }}
      >
        {timeLineEvent?.sub_status ? (
          <TimeLineAltCard
            timeLineEvent={timeLineEvent}
            isDeletable={isDeletable && !timeLineEvent.disabled}
            isDeleted={timeLineEvent.disabled}
            showModal={showModal}
          />
        ) : (
          <TimeLineMainCard
            timeLineEvent={timeLineEvent}
            isDeletable={isDeletable && !timeLineEvent.disabled}
            isDeleted={timeLineEvent.disabled}
            showModal={showModal}
          />
        )}
      </Col>
      <CancelLifecyleModal
        timeLineEvent={timeLineEvent}
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        lpUi={lpUi}
        onRefetch={onRefetch}
      />
    </Row>
  );
};
